import React, { useState } from 'react';
import Switch from "react-switch";
import { SwitchLeftText, SwitchRightText, Title, TitleContainer } from './Title.styled';

interface TitleSectionProps {
    onToggleChange: (isToggled: boolean) => void;
}

const TitleSection: React.FC<TitleSectionProps> = ({ onToggleChange }) => {
    const [isToggled, setIsToggled] = useState<boolean>(false);

    const handleToggle = () => {
        setIsToggled(prevState => {
            const newState = !prevState;
            onToggleChange(newState);
            return newState;
        });
    };

    return (
        <TitleContainer>
            <Title>{!isToggled ? 'Changelogs Timeline' : 'Checksums - validate your download'}</Title>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <SwitchLeftText>Changelogs</SwitchLeftText>
                <Switch
                    onChange={handleToggle}
                    checked={isToggled}
                    onColor="#4b4b4b"
                    offColor="#18A957"
                    uncheckedIcon={false}
                    checkedIcon={false}
                    height={20}
                    width={50}
                    handleDiameter={20}
                />
                <SwitchRightText>Checksums</SwitchRightText>
            </div>
        </TitleContainer>
    );
}

export default TitleSection;
